import { Flex, Typography } from "antd"

const { Title } = Typography

/**
 * Common header component for Health subpages
 * Displays title and optional filter controls
 */
const HealthSubpageHeader = ({ title, children }) => {
  return (
    <Flex justify="space-between" align="center">
      <div>
        <Title level={4} style={{ marginBottom: 0 }}>
          {title}
        </Title>
      </div>
      {children && (
        <Flex gap={8} align="center">
          {children}
        </Flex>
      )}
    </Flex>
  )
}

export default HealthSubpageHeader
